import { axios } from '../http-common';

class Topup {

  request(data){
  	return axios.post("v1/cobrand/deposit/direct",data);
  }
  load(data){
    return axios.post("v1/cobrand/deposit/validate-card",data);
  }
  chain(){
    return axios.get("v1/cobrand/deposit/info");
  }
    
}

export default new Topup();